module.exports = __webpack_public_path__ + "img/ic_question_notice_black_selected.9672384e.svg";